import React from 'react';

const FAQ: React.FC = () => {
  return (
    <div className="faqPage" data-testid="faqPage" />
  );
};

export default FAQ;
